export default __webpack_public_path__ + "static/media/img3.e5d23d1e.png";